import { DateTime } from "luxon";

export default function( value, format ) {
  if (!value) {
    return "";
  }

  let d = null;
  if (typeof value === "string") {
    d = new Date(value);
  } else if (value instanceof Date) {
    d = value;
  }

  if (!d) {
    return "";
  }

  // Find formats and what they are here: https://moment.github.io/luxon/#/formatting
  format = format || "DATETIME_SHORT";
  if (DateTime[format] && typeof DateTime[format] === "object") {
    format = DateTime[format];
  } else {
    format = DateTime.DATETIME_SHORT;
  }

  return DateTime.fromJSDate(d).toLocaleString(format);
}
